import { Injectable } from "@angular/core";
import { RestrictionView } from "@core/models/viewmodel/restriction.view";

/**
 * TaskContextService
 *
 * This service provides a context for managing the current task view in the application.
 * It allows setting, retrieving, and clearing the task view, which is used to store and manage the state of a task-related view.
 *
 * The service is designed to be used as a singleton, ensuring that the task view context is consistent across the application.
 *
 * Key Features:
 * - Set the task view using the `setTaskView` method.
 * - Retrieve the current task view using the `getTaskView` method.
 * - Clear the task view using the `clear` method.
 */
@Injectable({ providedIn: "root" })
export class TaskContextService {
  private _taskView: RestrictionView | null = null;

  setTaskView(view: RestrictionView) {
    this._taskView = view;
  }

  getTaskView(): RestrictionView | null {
    return this._taskView;
  }

  clear() {
    this._taskView = null;
  }
}
